import { gql, TypedDocumentNode } from "@apollo/client";

import { AwsIntegration, Space } from "types/generated";

type AttachedStack = Pick<
  AwsIntegration["attachedStacks"][number],
  "id" | "stackId" | "stackName" | "isModule" | "isAutoattached"
> & {
  spaceDetails: Pick<Space, "id" | "name">;
};

type AttachedScan = Pick<AwsIntegration["attachedScans"][number], "scanId" | "scanName"> & {
  spaceDetails: Pick<Space, "id" | "name">;
};

export type AwsIntegrationView = Pick<
  AwsIntegration,
  | "id"
  | "name"
  | "roleArn"
  | "durationSeconds"
  | "generateCredentialsInWorker"
  | "autoattachEnabled"
  | "externalId"
  | "region"
  | "labels"
  | "hasAttachedStacks"
  | "hasAttachedScans"
  | "tagAssumeRole"
> & {
  spaceDetails: Pick<AwsIntegration["spaceDetails"], "id" | "name" | "accessLevel">;
  attachedStacks: AttachedStack[];
  attachedScans: AttachedScan[];
};

type GetAwsIntegrationData = {
  awsIntegration?: AwsIntegrationView;
};

export const GET_AWS_INTEGRATION: TypedDocumentNode<GetAwsIntegrationData> = gql`
  query GetAwsIntegration($id: ID!) {
    awsIntegration(id: $id) {
      id
      name
      roleArn
      durationSeconds
      generateCredentialsInWorker
      autoattachEnabled
      externalId
      region
      labels
      tagAssumeRole
      spaceDetails {
        id
        name
        accessLevel
      }
      hasAttachedStacks
      attachedStacks {
        id
        stackId
        stackName
        isModule
        isAutoattached
        spaceDetails {
          id
          name
        }
      }
      hasAttachedScans
      attachedScans {
        scanId
        scanName
        spaceDetails {
          id
          name
        }
      }
    }
  }
`;
